import { forwardRef, HTMLAttributes } from "react";
import {
  Label as ReactAriaLabel,
  type LabelProps as ReactAriaLabelProps,
} from "react-aria-components";

import { cn } from "../utils";

export const ncLabelClasses =
  "inline-flex items-center gap-0.5 shrink-0 font-bold leading-tight cursor-pointer";

const requiredAsteriskClasses = "after:text-danger after:content-['*'/'required']";

interface NcLabelProps extends ReactAriaLabelProps {
  isRequired?: boolean;
  hideLabel?: boolean;
}

export const NcLabel = forwardRef<HTMLLabelElement, NcLabelProps>(
  ({ children, isRequired, hideLabel, ...props }, ref) => {
    return (
      <ReactAriaLabel
        data-nc="NcLabel"
        ref={ref}
        className={cn(
          ncLabelClasses,
          hideLabel && "sr-only",
          isRequired && !hideLabel && requiredAsteriskClasses
        )}
        {...props}
      >
        {children}
      </ReactAriaLabel>
    );
  }
);

interface NcRequiredTextProps extends HTMLAttributes<HTMLSpanElement> {
  isRequired?: boolean;
  hideLabel?: boolean;
}

export const NcLabelText = ({ children, isRequired, hideLabel, ...props }: NcRequiredTextProps) => (
  <span
    data-nc="NcLabelText"
    className={cn(
      ncLabelClasses,
      hideLabel && "sr-only",
      isRequired && !hideLabel && requiredAsteriskClasses
    )}
    {...props}
  >
    {children}
  </span>
);
